var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.33 27.958C17.8635 26.5665 19.2827 25.0541 20.574 23.4353C23.294 20.018 24.9487 16.6487 25.0607 13.6527C25.105 12.4351 24.9034 11.221 24.468 10.0831C24.0327 8.94509 23.3724 7.90654 22.5266 7.02947C21.6809 6.15239 20.6671 5.45477 19.5457 4.97829C18.4243 4.5018 17.2184 4.25622 16 4.25622C14.7816 4.25622 13.5757 4.5018 12.4543 4.97829C11.3329 5.45477 10.3191 6.15239 9.47332 7.02947C8.62759 7.90654 7.96731 8.94509 7.53193 10.0831C7.09655 11.221 6.895 12.4351 6.93932 13.6527C7.05265 16.6487 8.70865 20.018 11.4273 23.4353C12.7186 25.0541 14.1378 26.5665 15.6713 27.958C15.8189 28.0913 15.9287 28.1882 16.0007 28.2487L16.33 27.958ZM15.0167 29.5114C15.0167 29.5114 5.33398 21.3567 5.33398 13.3327C5.33398 10.5037 6.45779 7.7906 8.45818 5.79021C10.4586 3.78982 13.1717 2.66602 16.0007 2.66602C18.8296 2.66602 21.5427 3.78982 23.5431 5.79021C25.5435 7.7906 26.6673 10.5037 26.6673 13.3327C26.6673 21.3567 16.9847 29.5114 16.9847 29.5114C16.446 30.0074 15.5593 30.002 15.0167 29.5114ZM16.0007 17.066C16.9908 17.066 17.9404 16.6727 18.6405 15.9725C19.3407 15.2724 19.734 14.3228 19.734 13.3327C19.734 12.3425 19.3407 11.393 18.6405 10.6928C17.9404 9.99268 16.9908 9.59935 16.0007 9.59935C15.0105 9.59935 14.0609 9.99268 13.3608 10.6928C12.6606 11.393 12.2673 12.3425 12.2673 13.3327C12.2673 14.3228 12.6606 15.2724 13.3608 15.9725C14.0609 16.6727 15.0105 17.066 16.0007 17.066ZM16.0007 18.666C14.5862 18.666 13.2296 18.1041 12.2294 17.1039C11.2292 16.1037 10.6673 14.7472 10.6673 13.3327C10.6673 11.9182 11.2292 10.5616 12.2294 9.56145C13.2296 8.56125 14.5862 7.99935 16.0007 7.99935C17.4151 7.99935 18.7717 8.56125 19.7719 9.56145C20.7721 10.5616 21.334 11.9182 21.334 13.3327C21.334 14.7472 20.7721 16.1037 19.7719 17.1039C18.7717 18.1041 17.4151 18.666 16.0007 18.666Z",
    fill: "url(#paint0_linear_926_1368)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_926_1368",
    x1: 5.33398,
    y1: 16.2737,
    x2: 26.6673,
    y2: 16.2737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#503D75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d3766864a5808d1751baa1717326f161.svg";
export { ForwardRef as ReactComponent };